import React, { useState } from "react"
import { Box, Button, createStyles, makeStyles } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import Ticker from "react-ticker"
// import "./styles.css";
import Play from "../assets/icons/icon-play-small.svg"
import Stop from "../assets/icons/icon-stop-small.svg"
import Up from "../assets/icons/icon-up-small.svg"
import Down from "../assets/icons/icon-down-small.svg"

const mod = modulus => num => ((num % modulus) + modulus) % modulus

const useStyles = makeStyles(() =>
  createStyles({
    tickerContainer: {
      background: "#FFFFFF",
      border: "1px solid #7D7D7D",
      boxSizing: "border-box",
      position: "relative",
      height: "100%",
      "@media (max-width: 576px)": {
        border: "none",
      },
    },
  }),
)

const TickerBox = ({ label, direction, marketPrice, time, variation }) => (
  <Box
    mr={1}
    p={1}
    style={{
      height: "50px",
    }}
  >
    <div>
      <div style={{ display: "flex", marginLeft: 25, alignItems: "center" }}>
        <Typography
          style={{
            fontFamily: "Gotham Bold",
            fontStyle: "normal",
            fontSize: "16px",
            letterSpacing: "0.480792px",
            textTransform: "uppercase",
            color: "#262626",
            whiteSpace: "nowrap",
          }}
          variant="h4"
        >
          {label} ✱ {time}
        </Typography>
        <div style={{ margin: "0 5px" }}>
          {direction ? (
            <img alt="up" src={Up} style={{ height: "12px" }} />
          ) : (
            <img alt="down" src={Down} style={{ height: "12px" }} />
          )}
        </div>
        <Typography
          style={{
            color: direction ? "#1D8728" : "#CA0000",
            fontSize: 14,
            fontWeight: 700,
            whiteSpace: "nowrap",
          }}
        >
          <span style={{
            padding: "5px 10px",
            background: direction ? "rgba(4, 183, 0, 0.2)" : "rgba(215, 0, 0, 0.2)",
            borderRadius: "40px",
            marginRight: "12px",
          }}>
            {marketPrice}
          </span>
          <span style={{
            padding: "5px 10px",
            background: direction ? "rgba(4, 183, 0, 0.2)" : "rgba(215, 0, 0, 0.2)",
            borderRadius: "40px",
          }}>
            {direction ? "+" : ""}
            {variation}
          </span>
        </Typography>
      </div>
    </div>
  </Box>
)

const getModularIndex = (array, i) => array[mod(array.length)(i)]

export default function CustomTicker() {
  const [move, setMove] = useState(true)
  const [cambios, setCambios] = React.useState(null)

  const classes = useStyles()


  React.useEffect(() => {
      const fetchUserEmail = async () => {
        try {
          // fetch(process.env.GATSBY_TICKER_URL)
          fetch("https://www.vectoronline.com.mx/img/data/data_front_0.xml")
            .then(resp => {
              return resp.text()
            })
            .then(data => {
              let xml = null
              try {
                // eslint-disable-next-line global-require
                const XMLParser = require("react-xml-parser")
                xml = new XMLParser().parseFromString(data)
              } catch (e) {
              }

              if (xml === null) {
                return
              }


              const changes = xml.children[1].children.map(dato => {
                const variation = dato.children[3].value
                const direction = !variation.includes("-")
                return {
                  label: dato.children[0].value,
                  time: dato.children[1].value,
                  marketPrice: dato.children[2].value,
                  variation,
                  direction,
                }
              })
              setCambios(changes)
            })
        } catch
          (error) {
          console.log(error.message)
        }
      }

      fetchUserEmail()
    }, [],
  )


  return (
    <>
      <div
        style={{
          // padding: "0 2rem",
          // marginBottom: 40,
          height: 50,
        }}
      >
        {cambios && (
          <>
            <div className={classes.tickerContainer}>
              <Button
                style={{
                  top: 0,
                  left: 0,
                  backgroundColor: "white",
                  height: "100%",
                  zIndex: 1,
                  position: "absolute",
                }}
                onClick={() => setMove(m => !m)}
              >
                {move ? (
                  <img alt="stop" src={Stop} style={{ height: "12px" }} />
                ) : (
                  <img alt="play" src={Play} style={{ height: "12px" }} />
                )}
              </Button>
              <div>
                <Ticker offset="run-in" speed={10} move={move} height={50}>
                  {({ index }) => TickerBox(getModularIndex(cambios, index))}
                </Ticker>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}
